import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';

import { SharedModule } from 'src/app/features/shared';
import { _windowFactory, windowToken } from 'src/app/window.token';

import { AudioVideoConnectionMonitorComponent, AudioVideoConnectionMonitorV2Component } from './components';
import { AudioVideoConnectionMonitorService } from 'src/app/features/audio-video-connection-monitor/services/audio-video-connection-monitor.service';
import { NavigatorMediaDeviceWrapperService } from 'src/app/features/audio-video-connection-monitor/services/navigator-media-device-wrapper.service';
import { AudioVideoConnectionMonitorReducers } from './store';

@NgModule({
  declarations: [AudioVideoConnectionMonitorComponent, AudioVideoConnectionMonitorV2Component],
  imports: [
    CommonModule,
    SharedModule,
    StoreModule.forFeature(
      'audioVideoConnectionMonitor',
      AudioVideoConnectionMonitorReducers.Reducers.audioVideoConnectionMonitorReducer
    ),
  ],
  providers: [
    AudioVideoConnectionMonitorService,
    NavigatorMediaDeviceWrapperService,
    {
      provide: windowToken,
      useFactory: _windowFactory,
    },
  ],
  exports: [AudioVideoConnectionMonitorComponent, AudioVideoConnectionMonitorV2Component],
})
export class AudioVideoConnectionMonitorModule {}
